import { render, staticRenderFns } from "./ProductCalcFooter.vue?vue&type=template&id=2b12e17e&scoped=true&"
import script from "./ProductCalcFooter.vue?vue&type=script&lang=js&"
export * from "./ProductCalcFooter.vue?vue&type=script&lang=js&"
import style0 from "./ProductCalcFooter.vue?vue&type=style&index=0&id=2b12e17e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12e17e",
  null
  
)

export default component.exports